<template>
    <b-row
        :id="`question-${template.question_code}-question-translation-group-${templateIdx}`"
        class="questionBar rounded"
        >
        <b-col
            :cols="4 - template.level"
            :offset="template.level"
            :class="['questionBar-title', `questionBar-level-${template.level}`]"
            >
            <div :title="isNameEmpty ? '(미입력)' : template.question_name">
                <h5 class="w-100 text-truncate mb-0">{{ template.question_name }}</h5>
                <b-badge class="font-weight-normal">{{ template.question_code }}</b-badge>
            </div>
        </b-col>
        <b-col cols="8" class="questionBar-body border">
            <b-row :class="['questionBar-status-bar border-bottom border-color-gray-500', { 'h-100': template.collapsed }]">
                <b-col col>
                    <b-row :class="[{'mb-3': template.collapsed}]">
                        <b-col cols="12">
                            <b-badge
                                :variant="needVariant(template.need_name_kr)"
                                class="mr-2 font-weight-normal"
                                >
                                제목 국문
                            </b-badge>
                            <b-badge
                                :variant="needVariant(template.need_name_translation)"
                                class="mr-2 font-weight-normal"
                                >
                                제목 번역
                            </b-badge>
                            <b-badge
                                :variant="needVariant(template.need_infobox_kr)"
                                class="mr-2 font-weight-normal"
                                >
                                배경정보 국문
                            </b-badge>
                            <b-badge
                                :variant="needVariant(template.need_infobox_translation)"
                                class="font-weight-normal"
                                >
                                배경정보 번역
                            </b-badge>
                            <b-badge v-if="template.load_failed" variant="danger" class="ml-2 font-weight-normal">
                                질문 정보를 불러오지 못함
                            </b-badge>
                        </b-col>
                    </b-row>
                    <b-row v-show="template.collapsed">
                        <b-col cols="6">
                            <h5 class="d-inline-block mb-0 text-truncate w-100">
                                <small class="mr-2">(제목)</small>
                                <span :class="[{ 'gray-500': isNameEmpty }]">
                                    {{ isNameEmpty ? '미입력' : template.question_name }}
                                </span>
                            </h5>
                        </b-col>
                        <b-col cols="6">
                            <h5 class="d-inline-block mb-0 text-truncate w-100">
                                <small class="mr-2">(배경정보)</small>
                                <span :class="[{ 'gray-500': isInfoboxEmpty }]">
                                    {{ isInfoboxEmpty ? '미입력' : template.question_infobox }}
                                </span>
                            </h5>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="auto" class="text-right">
                    <span v-show="!template.collapsed">
                        <b-btn class="mr-2"
                            size="sm"
                            variant="info"
                            @click="$emit('initialize', templateIdx, template.question_code)"
                            :disabled="inputDisabled"
                            >
                            번역 초기화하기
                        </b-btn>
                        <b-btn class="mr-2"
                            size="sm"
                            variant="primary"
                            @click="$emit('save', templateIdx)"
                            :disabled="inputDisabled || !template.edited"
                            >
                            저장하기
                        </b-btn>
                        <b-btn class="mr-2"
                            size="sm"
                            @click="$emit('toggle-edit', templateIdx)"
                            :disabled="disabled"
                            >
                            {{ template.show_info ? '편집하기' : '편집 닫기' }}
                        </b-btn>
                    </span>
                    <b-btn
                        size="sm"
                        @click="$emit('toggle-collapse', templateIdx)"
                        :disabled="disabled"
                        >
                        <BIconChevronDown :rotate="template.collapsed ? 0 : 180" />
                    </b-btn>
                </b-col>
            </b-row>
            <b-row v-show="!template.collapsed" class="questionBar-content">
                <b-col cols="12" v-show="template.show_info">
                    <b-row class="mb-2">
                        <b-col cols="6">
                            <p class="d-inline-block gray-600 font-weight-normal mr-2 mb-1">(제목)</p>
                            <h5 :class="['d-inline-block mb-0', { 'gray-500': isNameEmpty }]">{{ isNameEmpty ? '미입력' : template.question_name }}</h5>
                        </b-col>
                        <b-col cols="6">
                            <p class="d-inline-block gray-600 font-weight-normal mr-2 mb-1">(배경정보)</p>
                            <h5 :class="['d-inline-block mb-0', { 'gray-500': isInfoboxEmpty }]">{{ isInfoboxEmpty ? '미입력' : template.question_infobox }}</h5>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <p class="d-inline-block gray-600 font-weight-normal mr-2 mb-1">(영문)</p>
                            <h6 :class="['d-inline-block mb-0', { 'gray-500': isNameEnEmpty }]">{{ isNameEnEmpty ? '미입력' : template.question_name_e }}</h6>
                        </b-col>
                        <b-col cols="6">
                            <p class="d-inline-block gray-600 font-weight-normal mr-2 mb-0">(영문)</p>
                            <h6 :class="['d-inline-block mb-0', { 'gray-500': isInfoboxEnEmpty }]">{{ isInfoboxEnEmpty ? '미입력' : template.question_infobox_e }}</h6>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <p class="d-inline-block gray-600 font-weight-normal mr-2 mb-1">(중문)</p>
                            <h6 :class="['d-inline-block mb-0', { 'gray-500': isNameCnEmpty }]">{{ isNameCnEmpty ? '미입력' : template.question_name_c }}</h6>
                        </b-col>
                        <b-col cols="6">
                            <p class="d-inline-block gray-600 font-weight-normal mr-2 mb-0">(중문)</p>
                            <h6 :class="['d-inline-block mb-0', { 'gray-500': isInfoboxCnEmpty }]">{{ isInfoboxCnEmpty ? '미입력' : template.question_infobox_c }}</h6>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" v-show="!template.show_info">
                    <b-row>
                        <b-col cols="6">
                            <h4>{{ template.need_name_kr ? '(미입력)' : template.question_name }}</h4>
                            <b-link v-if="isNameEmpty" :to="editPageLink" class="d-inline-block small mb-2">국문은 질문지 편집 화면에서 입력합니다</b-link>
                            <b-form-group
                                :id="`question-${template.question_code}-${templateIdx}-question_name-e-group`"
                                label="(영문) 번역"
                                :label-for="`question-${template.question_code}-${templateIdx}-question_name-e`"
                                >
                                <b-form-input
                                    :id="`question-${template.question_code}-${templateIdx}-question_name-e`"
                                    v-model="template.question_name_e"
                                    @input="$emit('edit', templateIdx, immutableNameEn, $event)"
                                    :placeholder="namePlaceholderEn"
                                    :disabled="inputDisabled || isNameEmpty"
                                    trim
                                    />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <h4>{{ template.need_infobox_kr ? '(미입력)' : template.question_infobox }}</h4>
                            <b-link v-if="isInfoboxEmpty" :to="editPageLink" class="d-inline-block small mb-2">국문은 질문지 편집 화면에서 입력합니다</b-link>
                            <b-form-group
                                :id="`question-${template.question_code}-${templateIdx}-question_infobox-e-group`"
                                label="(영문)"
                                :label-for="`question-${template.question_code}-${templateIdx}-question_infobox-e`"
                                >
                                <b-form-textarea
                                    :id="`question-${template.question_code}-${templateIdx}-question_infobox-e`"
                                    v-model="template.question_infobox_e"
                                    rows="2"
                                    max-rows="8"
                                    @input="$emit('edit', templateIdx, immutableInfoboxEn, $event)"
                                    :placeholder="infoboxPlaceholderEn"
                                    :disabled="inputDisabled || isInfoboxEmpty"
                                    trim
                                    />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group
                                :id="`question-${template.question_code}-${templateIdx}-question_name-c-group`"
                                label="(중문)"
                                :label-for="`question-${template.question_code}-${templateIdx}-question_name-c`"
                                >
                                <b-form-input
                                    :id="`question-${template.question_code}-${templateIdx}-question_name-c`"
                                    v-model="template.question_name_c"
                                    @input="$emit('edit', templateIdx, immutableNameCn, $event)"
                                    :placeholder="namePlaceholderCn"
                                    :disabled="inputDisabled || isNameEmpty"
                                    trim
                                    />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                                :id="`question-${template.question_code}-${templateIdx}-question_infobox-c-group`"
                                label="(중문)"
                                :label-for="`question-${template.question_code}-${templateIdx}-question_infobox-c`"
                                >
                                <b-form-textarea
                                    :id="`question-${template.question_code}-${templateIdx}-question_infobox-c`"
                                    v-model="template.question_infobox_c"
                                    rows="2"
                                    max-rows="8"
                                    @input="$emit('edit', templateIdx, immutableInfoboxCn, $event)"
                                    :placeholder="infoboxPlaceholderCn"
                                    :disabled="inputDisabled || isInfoboxEmpty"
                                    trim
                                    />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
/**
 * 번역 편집 화면의 질문 1건(행).
 *
 * 원래 `EditingTemplateTranslation.vue` 템플릿에 인라인으로 있던 블록을 컴포넌트로
 * 분리한 것. 인라인일 때는 어느 행의 input 을 한 글자 치든 부모 data
 * (`template_contents`)가 갱신되어 **전체 v-for(수십 행)의 모든 바인딩이 재평가**됐다.
 * 행마다 `isValueEmpty` 10여 회 + `generatePlaceholder` 4회 + `:disabled` 표현식이
 * 있어 키 입력마다 수천 번의 재평가가 발생 → 타이핑이 눈에 띄게 지연됐다.
 *
 * 컴포넌트로 분리하면 Vue 가 렌더 스코프를 행 단위로 나누므로, 편집 중인 행만
 * 다시 그리고 나머지 행은 props 참조가 그대로여서 렌더 함수가 재실행되지 않는다.
 * 반복 평가되던 표현식도 computed 로 캐싱했다.
 *
 * `template` 객체의 속성을 직접 `v-model` 로 바인딩하는 구조는 분리 전과 동일하다
 * (부모 배열의 원소를 그대로 참조). 저장/초기화 등 부수효과는 부모가 그대로 담당하며
 * 이 컴포넌트는 이벤트만 올린다.
 */
export default {
    name: 'question-translation-row',
    props: {
        template: { type: Object, required: true },
        templateIdx: { type: Number, required: true },
        // template_contents_immutable[templateIdx] — 편집 여부(dirty) 판정 기준값
        immutable: { type: Object, default: () => ({}) },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        isNameEmpty () { return this.isValueEmpty(this.template.question_name) },
        isInfoboxEmpty () { return this.isValueEmpty(this.template.question_infobox) },
        isNameEnEmpty () { return this.isValueEmpty(this.template.question_name_e) },
        isNameCnEmpty () { return this.isValueEmpty(this.template.question_name_c) },
        isInfoboxEnEmpty () { return this.isValueEmpty(this.template.question_infobox_e) },
        isInfoboxCnEmpty () { return this.isValueEmpty(this.template.question_infobox_c) },

        immutableNameEn () { return this.immutable ? this.immutable.question_name_e : null },
        immutableNameCn () { return this.immutable ? this.immutable.question_name_c : null },
        immutableInfoboxEn () { return this.immutable ? this.immutable.question_infobox_e : null },
        immutableInfoboxCn () { return this.immutable ? this.immutable.question_infobox_c : null },

        namePlaceholderEn () { return this.generatePlaceholder('제목', this.template.question_name, '영문') },
        namePlaceholderCn () { return this.generatePlaceholder('제목', this.template.question_name, '중문') },
        infoboxPlaceholderEn () { return this.generatePlaceholder('배경 정보', this.template.question_infobox, '영문') },
        infoboxPlaceholderCn () { return this.generatePlaceholder('배경 정보', this.template.question_infobox, '중문') },

        // 저장 중(disabled)이거나 질문 정보를 못 불러온 행은 번역 칸·저장·초기화를 잠근다
        inputDisabled () { return this.disabled || !!this.template.load_failed },
        // 국문이 비어 번역할 수 없을 때 국문을 입력할 곳(질문지 편집 화면의 그 질문)
        editPageLink () {
            return {
                name: 'EditingTemplate',
                query: { value_new: false, template_id: this.$route.params.template_code, question_id: this.template.question_code }
            }
        },
    },
    methods: {
        // 질문 정보를 못 불러온 행은 번역 상태를 모른다 — 입력됨(파랑)·미입력(노랑) 대신 회색
        needVariant (need) {
            if (this.template.load_failed) return 'secondary'
            return need ? 'warning' : 'primary'
        },
        isValueEmpty (val) {
            return !val || val.trim() === ''
        },
        generatePlaceholder (unit, kr, forn) {
            if (!kr || kr.trim() === '') {
                return `질문의 ${unit}에 대한 국문이 없습니다. ${unit}를(을) 먼저 입력해주세요.`
            } else {
                return `질문의 ${unit}에 대한 ${forn} 번역을 입력해주세요.`
            }
        },
    },
}
</script>

<style lang="scss" scoped>

// 부모(EditingTemplateTranslation.vue)에 있던 행 스타일을 그대로 가져왔다.
// scoped 는 자식 컴포넌트의 루트 요소에만 부모 scope id 를 부여하므로,
// 행 내부 요소(-title / -body / -level-* …)의 스타일은 이 컴포넌트가 소유해야 한다.
// 행 사이 마진(.questionBar + .questionBar)만 형제 관계라 부모에 남겨두었다.
.questionBar {
    &-title {
        padding: 1rem 1rem;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;

        h4 {
            word-break: keep-all
        }
    }

    &-body {
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
    }

    &-status-bar {
        padding: 1rem 0rem;
    }

    &-content {
        padding: 1rem 0rem;
    }

    &-level-0 {
        background-color: var(--gray-300);
        font-weight: 600;
    }

    &-level-1 {
        background-color: var(--gray-200);
        font-weight: 500;
    }

    &-level-2 {
        background-color: var(--gray-100);
        font-weight: 500;
    }
}

</style>
